import { ImpersonationInitResponse } from './api';

export type OpenWindowFn = (url: string) => Window | null;

export interface StartImpersonationResult {
  errorMessage?: string;
}

const DEFAULT_IMPERSONATION_ERROR = 'Failed to start impersonation. Please try again.';

export const getImpersonationErrorMessage = (error: unknown): string => {
  const apiMessage = (error as any)?.data?.message;
  if (typeof apiMessage === 'string' && apiMessage.trim()) {
    return apiMessage;
  }

  const fallbackMessage = (error as any)?.error;
  if (typeof fallbackMessage === 'string' && fallbackMessage.trim()) {
    return fallbackMessage;
  }

  return DEFAULT_IMPERSONATION_ERROR;
};

export const openImpersonationWindow = (
  redirectUrl: string,
  openWindow: OpenWindowFn = (url) => window.open(url, '_blank', 'noopener,noreferrer')
): void => {
  try {
    openWindow(redirectUrl);
  } catch {
    // Ignore popup/browser-level failures and keep API flow successful.
  }
};

export const startUserImpersonation = async (
  userId: number,
  initiateImpersonation: (id: number) => Promise<ImpersonationInitResponse>,
  openWindow: OpenWindowFn = (url) => window.open(url, '_blank', 'noopener,noreferrer')
): Promise<StartImpersonationResult> => {
  try {
    const response = await initiateImpersonation(userId);
    openImpersonationWindow(response.redirect_url, openWindow);
    return {};
  } catch (error) {
    return {
      errorMessage: getImpersonationErrorMessage(error),
    };
  }
};
